<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate (ngSubmit)="save(editForm.value)" [formGroup]="editForm">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-plugin-table">
          <tbody style="vertical-align: top">
            <tr class="th-plugin-line--subheader">
              <td style="width: 30%">
                <span>{{ 'plugins.training-proposal.module' | translate }}</span>
              </td>
              <td style="width: 30%">
                <span>{{ 'plugins.training-proposal.trainee' | translate }}</span>
              </td>
              <td style="width: 10%">
                <span
                  >{{ 'plugins.training-proposal.duration' | translate }} ({{
                    'plugins.training-proposal.days' | translate
                  }})</span
                >
              </td>
              <td style="width: 30%">
                <span>{{ 'plugins.training-proposal.when' | translate }}</span>
              </td>
            </tr>
            <tr
              class="th-plugin-line--input"
              style="width: 30%"
              formArrayName="trainingProposals"
              *ngFor="let item of formData.controls; let i = index"
            >
              <td style="width: 30%" [formGroupName]="i">
                <div class="ir-form-group margin">
                  <input
                    formControlName="Course"
                    placeholder="{{ 'plugins.training-proposal.training-name' | translate }}"
                    class="ir-form-set"
                    type="text"
                  />
                </div>
              </td>
              <td class="th-plugin-line--value" style="width: 30%">
                <div class="ir-line ir-select th-select" (click)="openTrainersSelector(i)">
                  <div class="ir-line--right">
                    <div class="ir-btn th-btn-modal--content">
                      <i class="material-icons">arrow_drop_down</i>
                    </div>
                  </div>
                  <div class="ir-line-content">
                    <span [innerHtml]="getSelectedValues(item.controls.Trainees.value)"></span>
                  </div>
                </div>
              </td>
              <td style="width: 10%" [formGroupName]="i">
                <div class="ir-form-group margin">
                  <input formControlName="Time" placeholder="0" class="ir-form-set" type="number" min="0" />
                </div>
              </td>
              <td style="width: 30%" [formGroupName]="i">
                <div class="ir-form-group margin">
                  <input
                    formControlName="Moment"
                    placeholder="{{ 'plugins.training-proposal.select-recommended-time' | translate }}"
                    class="ir-form-set"
                    type="text"
                  />
                </div>
              </td>
              <td class="th-plugin-line--remove">
                <i class="material-icons" (click)="remove(i)">remove_circle</i>
              </td>
            </tr>
            <tr class="th-plugin-line--add">
              <td colspan="4">
                <i class="material-icons" (click)="add()">add_circle</i>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="!editForm.valid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal (modalOutput)="selectTrainersMenu($event)" #traineesModal></modal>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
